import {fetch} from "utils/dataAccess";

export default async function markAllAsRead(memberId) {
    const response = await fetch(`/notifications/mark_all_as_read?member=${memberId}`);

    if (!response.ok) throw new Error('Failed to mark all as read notifications');

    return await response.json();
}
